import { useTranslation } from 'react-i18next';

const LANGUAGES = [
  { code: 'en', label: 'EN' },
  { code: 'ja', label: 'JA' },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  return (
    <select
      value={i18n.language?.substring(0, 2) || 'en'}
      onChange={e => i18n.changeLanguage(e.target.value)}
      className="text-sm bg-gray-100 border-none rounded px-2 py-1 cursor-pointer"
    >
      {LANGUAGES.map(lang => (
        <option key={lang.code} value={lang.code}>
          {lang.label}
        </option>
      ))}
    </select>
  );
}
